import React, { useEffect } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel with the provided ID using the standard Facebook Pixel approach
    if (typeof window !== 'undefined') {
      // Create fbq function if it doesn't exist
      if (!window.fbq) {
        window.fbq = function () {
          window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
        };
        window.fbq.queue = [];
        window.fbq.version = '2.0';
      }
      // Initialize the pixel
      window.fbq('init', '1119732203535463');
      // Track PageView on component mount
      window.fbq('track', 'PageView');
    }
    return () => {
      // Clean up if needed
    };
  }, []);
  return null; // This component doesn't render anything
}
// Utility function to track Add To Cart event
export const trackAddToCart = () => {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: '30 Días Frecuencia Prohibida',
        content_type: 'product',
        content_ids: ['W101883420N'],
        value: 39195.0,
        currency: 'ARS'
      });
      console.log('AddToCart event tracked');
    }
  } catch (error) {
    console.error('Error tracking AddToCart event:', error);
  }
};
// Declare fbq function for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}